<div [formGroup]="this.form">
    <label for="partner">Company</label>

    <div class="ng-autocomplete">
        <ng-autocomplete
            [data]="partners"
            [searchKeyword]="partnerKeyword"
            formControlName="partner"
            [initialValue]="this.initialValue"
            autocomplete="off"
            [itemTemplate]="partnerTemplate"
            [notFoundTemplate]="partnerNotFoundTemplate"
            placeholder="Choose a company">
        </ng-autocomplete>

        <ng-template
            #partnerTemplate
            let-item>
            <a [innerHTML]="item.title"></a>
        </ng-template>

        <ng-template
            #partnerNotFoundTemplate
            let-notFound>
            <p>No companies found...</p>
        </ng-template>
    </div>

    <button
        class="button button--outline button--icon m-l-12"
        (click)="openAddPartnerModal()">
        <i class="las la-plus"></i>
    </button>
</div>
